(() => {
  if (document.querySelector('.eco-pc-calendar')) return;
  const copy = document.getElementById('EcoDesktopCalendarCopy');
  if (!copy) return;
  let labels;
  try { labels = JSON.parse(copy.textContent).split('|'); } catch { return; }
  const desktop = window.matchMedia('(min-width: 750px)');
  const popup = document.createElement('dialog');
  if (typeof popup.show !== 'function') return;
  popup.className = 'eco-pc-calendar';
  popup.id = 'EcoDesktopCalendar';
  popup.setAttribute('aria-label', labels[0]);
  const make = (tag, className, text = '') => {
    const element = document.createElement(tag);
    element.className = className;
    element.textContent = text;
    return element;
  };
  const button = (text, name) => {
    const element = make('button', '', text);
    element.type = 'button';
    if (name) element.setAttribute('aria-label', name);
    return element;
  };
  const header = make('div', 'eco-pc-calendar__header');
  const previous = button('‹', labels[1]), next = button('›', labels[2]);
  const title = make('h2', 'eco-pc-calendar__title');
  title.setAttribute('aria-live', 'polite');
  header.append(previous, title, next);
  const week = make('div', 'eco-pc-calendar__week');
  week.setAttribute('aria-hidden', 'true');
  const days = make('div', 'eco-pc-calendar__days');
  const footer = make('div', 'eco-pc-calendar__footer');
  const clear = button(labels[3]), todayButton = button(labels[4]), dismiss = button(labels[5]);
  footer.append(clear, todayButton, dismiss);
  popup.append(header, week, days, footer);
  document.body.append(popup);
  let active, month, cursor, locale = labels[6], savedAttributes;
  const date = (value) => /^\d{4}-\d{2}-\d{2}$/.test(value || '') ? new Date(value + 'T12:00:00') : null;
  const iso = (value) => `${value.getFullYear()}-${String(value.getMonth()+1).padStart(2,'0')}-${String(value.getDate()).padStart(2,'0')}`;
  const midnight = (value) => Date.UTC(value.getFullYear(), value.getMonth(), value.getDate());
  const allowed = (value) => {
    if (!active || active.disabled || active.readOnly) return false;
    const key = iso(value), min = date(active.min), max = date(active.max);
    if (min && key < active.min || max && key > active.max) return false;
    const step = active.step === 'any' ? 0 : Number(active.step || 1);
    const base = min || date(active.getAttribute('value')) || new Date(1970, 0, 1, 12);
    return !(step > 0) || Math.abs(((midnight(value)-midnight(base))/86400000)/step - Math.round(((midnight(value)-midnight(base))/86400000)/step)) < 1e-7;
  };
  const anchor = (input) => input.closest('.eco-search__field, .eco-rooms-search__field, .eco-results-search label') || input;
  const position = () => {
    if (!active || !popup.open) return;
    const rect = anchor(active).getBoundingClientRect();
    const width = popup.offsetWidth, height = popup.offsetHeight;
    const top = rect.bottom + 8 + height <= innerHeight - 12 ? rect.bottom + 8 : Math.max(12, rect.top - height - 8);
    popup.style.left = `${Math.max(12, Math.min(rect.left, innerWidth-width-12))}px`;
    popup.style.top = `${Math.max(12, Math.min(top, innerHeight-height-12))}px`;
  };
  const close = (restore = true) => {
    if (!active) return;
    const input = active;
    active = null;
    popup.close();
    for (const [name, value] of savedAttributes) value === null ? input.removeAttribute(name) : input.setAttribute(name, value);
    if (restore && input.isConnected) input.focus({preventScroll:true});
  };
  const paint = (focusDay = false) => {
    title.textContent = new Intl.DateTimeFormat(locale,{month:'long',year:'numeric'}).format(month);
    week.replaceChildren();
    for (let i=0;i<7;i++) {
      const value = new Intl.DateTimeFormat(locale,{weekday:'short'}).format(new Date(2026,0,5+i,12));
      week.append(make('span','',locale.startsWith('es') ? ['L','M','X','J','V','S','D'][i] : value));
    }
    days.replaceChildren();
    const year = month.getFullYear(), index = month.getMonth();
    for (let i=0;i<(new Date(year,index,1).getDay()+6)%7;i++) days.append(make('span',''));
    let first, target;
    for (let day=1;day<=new Date(year,index+1,0).getDate();day++) {
      const value = new Date(year,index,day,12), key = iso(value);
      const cell = button(String(day),new Intl.DateTimeFormat(locale,{weekday:'long',year:'numeric',month:'long',day:'numeric'}).format(value));
      cell.dataset.date = key;
      cell.disabled = !allowed(value);
      cell.tabIndex = -1;
      cell.setAttribute('aria-pressed', String(key === active.value));
      if (key === iso(new Date())) cell.setAttribute('aria-current','date');
      if (!cell.disabled) { first ||= cell; if (key === iso(cursor)) target = cell; }
      cell.addEventListener('click', () => select(key));
      days.append(cell);
    }
    target ||= first;
    if (target) { target.tabIndex = 0; cursor = date(target.dataset.date); }
    const min = date(active.min), max = date(active.max);
    previous.disabled = !!min && new Date(year,index,0,12) < min;
    next.disabled = !!max && new Date(year,index+1,1,12) > max;
    todayButton.disabled = !allowed(new Date());
    position();
    if (focusDay) (target || dismiss).focus({preventScroll:true});
  };
  const select = (value) => {
    if (value && !allowed(date(value))) return;
    const input = active;
    input.value = value;
    close();
    input.dispatchEvent(new Event('input',{bubbles:true}));
    input.dispatchEvent(new Event('change',{bubbles:true}));
  };
  const open = (input) => {
    if (active) close(false);
    active = input;
    locale = input.lang || labels[6] || document.documentElement.lang || 'es-ES';
    try { new Intl.DateTimeFormat(locale); } catch { locale = 'es-ES'; }
    savedAttributes = ['aria-expanded','aria-controls','aria-haspopup'].map(name => [name,input.getAttribute(name)]);
    input.setAttribute('aria-expanded','true');
    input.setAttribute('aria-controls',popup.id);
    input.setAttribute('aria-haspopup','dialog');
    cursor = date(input.value) || new Date();
    if (date(input.min) && iso(cursor)<input.min) cursor = date(input.min);
    if (date(input.max) && iso(cursor)>input.max) cursor = date(input.max);
    month = new Date(cursor.getFullYear(),cursor.getMonth(),1,12);
    popup.show();
    paint(true);
  };
  const findInput = (target) => {
    if (!(target instanceof Element)) return null;
    const direct = target.closest('input[type="date"]');
    const field = target.closest('label, .eco-search__field, .eco-rooms-search__field');
    const input = direct || field?.querySelector('input[type="date"]');
    return input && !input.disabled && !input.readOnly && input.getClientRects().length && !input.closest('[inert]') ? input : null;
  };
  document.addEventListener('click', event => {
    if (!desktop.matches || popup.contains(event.target)) return;
    const input = findInput(event.target);
    if (input) { event.preventDefault(); event.stopPropagation(); open(input); }
    else close(false);
  },true);
  document.addEventListener('keydown', event => {
    if (!desktop.matches) return;
    if (active && event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (!popup.contains(event.target) && ['Enter',' ','ArrowDown'].includes(event.key)) {
      const input = findInput(event.target);
      if (input) { event.preventDefault(); event.stopPropagation(); open(input); }
    }
  },true);
  days.addEventListener('keydown', event => {
    const offset = {ArrowLeft:-1,ArrowRight:1,ArrowUp:-7,ArrowDown:7}[event.key];
    if (offset === undefined && !['Home','End','PageUp','PageDown'].includes(event.key)) return;
    event.preventDefault();
    const value = new Date(cursor);
    if (offset !== undefined) value.setDate(value.getDate()+offset);
    if (event.key === 'Home') value.setDate(value.getDate()-(value.getDay()+6)%7);
    if (event.key === 'End') value.setDate(value.getDate()+6-(value.getDay()+6)%7);
    if (event.key === 'PageUp' || event.key === 'PageDown') {
      const day = value.getDate(); value.setDate(1); value.setMonth(value.getMonth()+(event.key === 'PageUp'?-1:1));
      value.setDate(Math.min(day,new Date(value.getFullYear(),value.getMonth()+1,0).getDate()));
    }
    if (!allowed(value)) return;
    cursor = value; month = new Date(value.getFullYear(),value.getMonth(),1,12); paint(true);
  });
  previous.addEventListener('click', () => { month.setMonth(month.getMonth()-1); paint(); });
  next.addEventListener('click', () => { month.setMonth(month.getMonth()+1); paint(); });
  clear.addEventListener('click', () => select(''));
  todayButton.addEventListener('click', () => select(iso(new Date())));
  dismiss.addEventListener('click', () => close());
  popup.addEventListener('cancel', event => { event.preventDefault(); close(); });
  document.addEventListener('focusin', event => { if (active && event.target !== active && !popup.contains(event.target)) close(false); });
  window.addEventListener('resize', () => desktop.matches ? position() : close(false));
  window.addEventListener('scroll', position, true);
  desktop.addEventListener('change', () => { if (!desktop.matches) close(false); });
})();
